/**
 * Alert
 */
// Module Dependencies
import 'protons';
import $ from 'jquery';

// Module styles
import './_smart_calc.scss';

export const name = 'smartCalc';

export function disable() {}

export function enable($dom) {
  const hash = window.location.hash.slice(1);
  let $calc;

  if (hash === 'kazenmaierbikeleasingrechner') {
    $calc = $($dom).find('.smart-calc');
  } else if (hash === 'kazenmaierbikeleasingexpertenrechner') {
    $calc = $($dom).find('.expert-calc a:visible');
    $calc.click();
  }

  if ($calc && $calc.length > 0) {
    // needed, b/c the page scrolls back to top for some reason ...
    setTimeout(() => {
      const offset = $calc.offset().top - 20;
      $(window).scrollTop(offset);
    }, 100);
  }
}

export default enable;
